import { atom } from "recoil"
import { Key } from "../EnumKey"
import { IDataRemoved } from "../../models/IDataRemoved"

const selectedDataAtom = atom({
  key: Key.SELECTEDDATA,
  default: [] as IDataRemoved[]
})

export default selectedDataAtom